<div class="grid grid--va-middle" *ngIf="items && items.length">
  <div class="grid__box grid__box--size-min">
    <button
      [ngbPopover]="searchPopContent"
      placement="bottom-left"
      triggers="manual"
      #p2="ngbPopover"
      autoClose="outside"
      (click)="toggleWithSearch(p2)"
      (hidden)="searchPopoverHideCell()"
      class="ctrl link link--dotted-blue-dark"
    >
      Изменить
    </button>
  </div>
  <div class="grid__box grid__box--size-min" *ngIf="countSelectedItems && countSelectedItems < items.length">
    <span class="text-italic color-gray-dark">Выбрано {{ countSelectedItems }} из {{ items.length }}</span>
  </div>
</div>

<div class="grid" *ngIf="!items || !items.length">
  <div class="grid__box grid__box--size-min">
    <span class="link link--dotted-gray-dark link--disabled link--pointer-events"
          ngbPopover="{{ emptyItemsMessage }}"
          triggers="mouseenter:mouseleave"
          placement="bottom-left"> Изменить </span>
  </div>
  <div class="grid__box grid__box--size-min pos-r" *ngIf="isLoading">
    <app-loader [size]="'small'" [position]="'reset'"></app-loader>
  </div>
</div>

<ng-template #searchPopContent>
  <div style="max-width: 418px">
    <div class="grid mb-8" *ngIf="mode === 'multiple'">
      <div class="grid__box grid__box--size-min">
        <app-checkbox>
          <input type="checkbox" id="checkAll" [(ngModel)]="isAllChecked" (change)="onChangeAllChecked($event)" />
          <checkbox-text>Выбрать все</checkbox-text>
        </app-checkbox>
      </div>
      <div class="grid__box grid__box--size-min">
        <app-checkbox>
          <input type="checkbox" id="showChecked" [(ngModel)]="isShowOnlyChecked" (change)="onChangeShowOnlyChecked($event)" />
          <checkbox-text>Показать выбранные</checkbox-text>
        </app-checkbox>
      </div>
    </div>
    <div class="border-bottom border-bottom--gray-bright mb-8" *ngIf="mode === 'multiple'"></div>
    <div>
      <app-field>
        <content-prefix>
          <div class="field__input-prefix">
            <app-icon [glyph]="'search'" [size]="'16'" [color]="'gray-dark'"></app-icon>
          </div>
        </content-prefix>
        <input type="text" class="input-text input--prefix" id="searchText" (keyup)="searchText = $event.target.value" />
      </app-field>
    </div>
    <div class="search__items mt-16">
      <div class="search__item mb-8" *ngFor="let item of items | showActive: checkedKey : isShowOnlyChecked | searchTextFilter: searchText : textKey">
        <app-checkbox *ngIf="mode === 'multiple'">
          <input type="checkbox" id="{{ 'item_checkbox_' + item[textKey] }}" [checked]="item['is_checked']" (change)="onChangeItem($event, item)" />
          <checkbox-text><span [innerHTML]="item[textKey] | highlightText: searchText"></span></checkbox-text>
        </app-checkbox>
        <app-radio-button *ngIf="mode === 'single'">
          <input
            type="radio"
            name="itemRadio"
            id="{{ 'item_radio_' + item[textKey] }}"
            [value]="item[textKey]"
            [(ngModel)]="singleSelectedItem"
            (change)="onChangeSingleItem(item)"
          />
          <radio-button-text><span [innerHTML]="item[textKey] | highlightText: searchText"></span> </radio-button-text>
        </app-radio-button>
      </div>
      <div *ngIf="!(items | showActive: checkedKey : isShowOnlyChecked | searchTextFilter: searchText : textKey).length">Ничего не найдено.</div>
    </div>
  </div>
</ng-template>
